import { Schemas } from "../../types";
import type { AustralianCriminalOption } from "./constants";

export type CriminalRecordTemplate = Schemas["CriminalRecordTemplateCreate"];

export type CriminalRecordTemplateUpdateRequest =
  Schemas["CriminalRecordTemplateUpdate"];

export type AustralianOrderingFlags =
  Schemas["CriminalRecordAustralianOrdering"];

export const LOCKED_AUSTRALIAN_ORDERING: AustralianOrderingFlags = {
  is_unlocked: false,
  enable_ordering_standard: false,
  enable_ordering_volunteer: false,
};

export type UsCriminalPreferenceEnum = Schemas["UsCriminalPreferenceEnum"];

export type UsCriminalCheckArguments = Schemas["UsCriminalCheckArguments"];

export type UsCriminalChecks = NonNullable<
  Schemas["CriminalCheckArgumentsCreate"]["us_criminal_checks"]
>;

export type CriminalRecordTemplateFormCheckArguments = Pick<
  Schemas["CriminalCheckArgumentsCreate"],
  | "umbrella_minimum_address_duration_months"
  | "umbrella_address_history_range_months"
  | "umbrella_apply_residency_rules_to_current_address"
  | "maximum_price"
  | "canadian_criminal_preference"
>;

/**
 * Form `check_arguments` is not the API nest. Canada binds
 * `check_arguments.canadian_criminal_preference` (one radio = one API enum).
 * AU cannot: one radio maps to `australian_criminal_preference` +
 * `australian_ncchc_check_type`, and Standard/Volunteer are both NCCHC.
 * US cannot reuse that single nested enum either: CUSTOM also owns a live
 * `us_criminal_checks` map that submit expands from preference. Both sit at
 * the root next to `australian_criminal_option`; submit maps them onto the API nest.
 */
export interface CriminalRecordTemplateFormValues
  extends Omit<CriminalRecordTemplate, "check_arguments"> {
  lookback_years?: number;
  australian_criminal_option?: AustralianCriminalOption;
  us_criminal_preference?: UsCriminalPreferenceEnum;
  us_criminal_checks?: UsCriminalChecks;
  check_arguments: CriminalRecordTemplateFormCheckArguments | null;
  id?: string;
  is_active?: boolean;
  is_in_use?: boolean;
  is_current_address?: Schemas["CriminalRecordTemplateDetail"]["is_current_address"];
}
